import type { ReactNode } from "react";
import ConcurrentLogoIcon from "../../../../../../../../../assets/svg/concurrent-logo-icon";
import PowerBiLogoPng from "../../../../../../../../../assets/images/power-bi-logo.png";
import HubspotLogoIcon from "../../../../../../../../../assets/svg/hubspot-logo-icon";
import PrismLogoPng from "../../../../../../../../../assets/images/prism-logo.png";
import VerbafloLogoPng from "../../../../../../../../../assets/images/verbaflo-logo.png";
import FeatureRequestStarIcon from "../../../../../../../../../assets/svg/feature-request-star-icon";
import AddUserIcon from "../../../../../../../../../assets/svg/add-user-icon";
import SettingsIcon from "../../../../../../../../../assets/svg/settings-icon";

const SYSTEM_ICON_MAP: Record<string, ReactNode> = {
  concurrent: <ConcurrentLogoIcon className="w-4 h-3.5" />,
  "power-bi": <img src={PowerBiLogoPng} alt="Power BI" className="w-4 h-3.5" />,
  hubspot: <HubspotLogoIcon className="w-4 h-4" />,
  prism: <img src={PrismLogoPng} alt="PRISM" className="w-4 h-3.5" />,
  verbaflo: <img src={VerbafloLogoPng} alt="VerbaFlo" className="w-4 h-4" />,
  "feature-requests": <FeatureRequestStarIcon className="w-4 h-3.5" />,
  "new-user-access": (
    <AddUserIcon className="w-4 h-3.5 text-verba-blue dark:text-verba-blue-dk" />
  ),
};

/** Icon for a system name option; falls back to a generic settings glyph. */
export function getSystemIcon(label: string): ReactNode {
  const key = label?.toLowerCase()?.replace(/\s+/g, "-");
  return (
    SYSTEM_ICON_MAP[key] ?? (
      <SettingsIcon className="w-4 h-4 text-verba-indigo dark:text-verba-indigo-dk" />
    )
  );
}
